import state from './moduleBankCashflowState.js'
import mutations from './moduleBankCashflowMutations.js'
import actions from './moduleBankCashflowActions.js'
import getters from './moduleBankCashflowGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

